import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { PopupInteractionNotifier } from '../notifiers/popup-interaction-notifier';
import { PopupInteractionState } from '../states/popup-interaction-state';

@Injectable({ providedIn: 'root' })
export class PopupInteractionProvider extends BaseProvider<PopupInteractionNotifier, PopupInteractionState> {
  constructor() {
    super(PopupInteractionNotifier);
  }
}
